<template>
  <v-main>
    <section>
      <Title :title="title" :img="img"></Title>
    </section>
    <v-sheet color="backgroundGrayColor" class="py-16" height="auto" style="border: solid rgb(220, 220, 220);">
      <v-container class="mx-auto" style="max-width: 1100px; background-color: white">
        <h3 xmlns="http://www.w3.org/1999/xhtml" id="sites-page-title-header" style="" align="left">
          <span id="sites-page-title" dir="ltr" tabindex="-1" style="outline: none">会社携帯の盗難・紛失時の対応方法について</span>
        </h3>
        <div dir="ltr" class="mt-6">
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small">お疲れさまです。</div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small"><br></div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small">
            会社携帯の盗難・紛失時の対応フローについて改めてお知らせいたします。
          </div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small">原則として</div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small"><br></div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small">
            <div style="color: #ff0000;">
              【紛失発覚から１時間経過した時点でデータをあきらめて消去】
            </div>
          </div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small"><br></div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small">となります。</div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small"><br></div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small">対応フローを簡記します。</div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small">１．スマホ紛失発覚、会社に報告</div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small">２．（可能なら）上長と一緒にスマホを探す</div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small">
            ３．（１から１時間経過しても見つからない場合）会社に報告するとともに、データ消去
          </div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small">４．最寄りの警察等に遺失物届出</div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small">５．情報セキュリティインシデント報告書提出</div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small"><br></div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small">みなさまご確認よろしくお願いいたします。<br></div>
          <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small"><br></div>
          <div style="display:block;text-align:left"><br></div>
          <div><br></div>
        </div>
        <v-img width="80%" src="@/assets/phoneLost.png" style="margin: 0 auto;"></v-img>
        <div style="color:rgb(34,34,34);font-family:arial,sans-serif;font-size:small">MRT ヘルプデスク（helpdesk@medrt.com）
        </div>
      </v-container>
    </v-sheet>
  </v-main>
</template>

<script>
import Title from '../components/Title';

export default {
  name: 'phoneLostView',
  components: {
    Title,
  },
  data() {
    return {
      title: '会社携帯の盗難・紛失時',
      img: 'title_emergencyContact.svg',
    };
  },
};
</script>